module.exports = __webpack_public_path__ + "img/icon_road.2d96ff92.svg";